import { connect, batch } from 'react-redux';

import { closeModal } from 'actions/modal';
import { getModalSelector } from 'selectors/modal';
import { getUserByIdSelector } from 'selectors/user';
import { MODAL_DELETE_MEMBER } from 'types/modal';
import  { actions } from '@amplement/backend-connector';

import BasicModal from './index';

const mapStateToProps = (state) => {
    const { _user, _feed } = getModalSelector(MODAL_DELETE_MEMBER)(state);
    const user = getUserByIdSelector(state, _user) || {};

    if (user) {
        return {
            _feed,
            _user,
            firstname: user.firstname,
            lastname: user.lastname
        };
    }

    return {
        error: 'Un problème est survenu'
    };
};

const mapDispatchToProps = dispatch => ({
    onClose: () => dispatch(closeModal(MODAL_DELETE_MEMBER)),
    onSubmit: (_feed, _user) => batch(() => {
        dispatch(closeModal(MODAL_DELETE_MEMBER));
        dispatch(actions.members.kickMemberFromFeed(_feed, _user));
    })
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BasicModal);
